/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './pharmacy-stock-closure.reducer';

export const PharmacyStockClosureDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const pharmacyStockClosureEntity = useAppSelector(state => state.pharmacyStockClosure.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="pharmacyStockClosureDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.pharmacyStockClosure.detail.title">PharmacyStockClosure</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.pharmacyStockClosure.id">Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockClosureEntity.id}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.pharmacyStockClosure.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockClosureEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.pharmacyStockClosure.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockClosureEntity.lastupdated}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.pharmacyStockClosure.active">Active</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockClosureEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.pharmacyStockClosure.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockClosureEntity.cursor}</dd>
          <dt>
            <span id="remainingQuantity">
              <Translate contentKey="tinyMedicRestApp.pharmacyStockClosure.remainingQuantity">Remaining Quantity</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockClosureEntity.remainingQuantity}</dd>
          <dt>
            <span id="forDate">
              <Translate contentKey="tinyMedicRestApp.pharmacyStockClosure.forDate">For Date</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockClosureEntity.forDate}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyStockClosure.consumableStock">Consumable Stock</Translate>
          </dt>
          <dd>{pharmacyStockClosureEntity.consumableStock ? pharmacyStockClosureEntity.consumableStock.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyStockClosure.implantStock">Implant Stock</Translate>
          </dt>
          <dd>{pharmacyStockClosureEntity.implantStock ? pharmacyStockClosureEntity.implantStock.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyStockClosure.drugStock">Drug Stock</Translate>
          </dt>
          <dd>{pharmacyStockClosureEntity.drugStock ? pharmacyStockClosureEntity.drugStock.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyStockClosure.pharmacy">Pharmacy</Translate>
          </dt>
          <dd>{pharmacyStockClosureEntity.pharmacy ? pharmacyStockClosureEntity.pharmacy.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/pharmacy-stock-closure" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/pharmacy-stock-closure/${pharmacyStockClosureEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PharmacyStockClosureDetail;
